export default "__VITE_ASSET__DANQFbLy__"